var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { IfThenElseFunctionEditor } from "abreact/expression/ui/editor/impl/model/impl/conditional/IfThenElseFunctionEditor";
import { AbVBox } from "abreact/layout/AbVBox";
import { observer } from "mobx-react";
import React from "react";
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;

export let IfThenElseEditor = observer(_class = class IfThenElseEditor extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return this.conditionalValueEditors;
  }
  get conditionalValueEditors() {
    return /*#__PURE__*/React.createElement(AbVBox, {
      spacing: true,
      className: "ab-gee-nonboolean-editor-conditional-outer"
    }, this.props.ifThenElseModel.modelList.map(operandValueModel => this.createConditionalValueEditor(operandValueModel, this.props.ifThenElseModel)));
  }
  createConditionalValueEditor(operandValueModel, model) {
    return /*#__PURE__*/React.createElement(IfThenElseFunctionEditor, {
      applyOperatorOperandValue: op => op && this.props.applyOperatorOperandValue(op),
      expressionDomainModel: this.props.expressionDomainModel,
      ifThenElseOperandValueModel: operandValueModel,
      ifThenElseModel: model,
      operandName: this.props.operandName,
      expressionComponentFactory: this.props.expressionComponentFactory,
      generateId: this.props.generateId
    });
  }
}) || _class;
//# sourceMappingURL=IfThenElseEditor.js.map
